// Top level "pack" file for webpack.
//
// This is for specifying what should be compiled as part of the asset bundle.
//
// Examples:
//   * JS written in a rails view or partial
//   * JS written in published content such as articles
//
// The ./server.js file should be used for any JS required to perform server
// side rendering.
import "../legacy_imports.js";
import "../react_on_rails_imports.js";

// import lazysizes for lazy loading images
import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

// TODO: import ahoy as a dependency when required.
// This is only imported here as ahoy appears to not be configured properly
// when directly imported.
import ahoy from 'ahoy.js';

// rails UJS is required for the "unobtrusive javascript" behavior that augments
// a variety of behaviors in a rails app.
var railsUJS = require('@rails/ujs');
railsUJS.start();

// application and components are the two directories that are compiled. This
// can be further split out to improve page performance in the future.
var applicationRequireContext = require.context('application', true);
var componentRequireContext = require.context('components', true);
var pageRequireContext = require.context('components/pages', true);
var ReactRailsUJS = require('react_ujs');

ReactRailsUJS.useContext(applicationRequireContext);
ReactRailsUJS.useContext(componentRequireContext);
ReactRailsUJS.useContext(pageRequireContext);
